import create, { GetState, SetState } from "zustand";

export enum AuthModalTypeEnum {
  SignIn = "SignIn",
  SignUp = "SignUp",
}

export type ModalStoreType = {
  authModalType: AuthModalTypeEnum;
  isAuthModalOpen: boolean;
  hideSignUpLink: boolean;
  openAuthModal: (
    authModalType: AuthModalTypeEnum,
    hideSignUpLink?: boolean
  ) => void;
  closeAuthModal: () => void;
  openSignUp: boolean;
  setOpenSignUp: (openSignUp: boolean) => void;
  signInType: string;
  setSignInType: (signInType: string) => void;
  openOTPModal: boolean;
  setOpenOTPModal: (openOTPModal: boolean) => void;
};

export const useModalStore = create<ModalStoreType>(
  (set: SetState<ModalStoreType>, get: GetState<ModalStoreType>) => ({
    authModalType: AuthModalTypeEnum.SignIn,
    isAuthModalOpen: false,
    hideSignUpLink: false,
    openAuthModal: (
      authModalType: AuthModalTypeEnum,
      hideSignUpLink?: boolean
    ) => {
      set((state) => {
        state.authModalType = authModalType;
        state.isAuthModalOpen = true;
        state.hideSignUpLink = hideSignUpLink || false;
      });
    },
    closeAuthModal: () => {
      set((state) => {
        state.isAuthModalOpen = false;
      });
    },
    openSignUp: false,
    setOpenSignUp: (openSignUp: boolean): void => {
      set((state) => {
        state.openSignUp = openSignUp;
      });
    },
    signInType: "normal",
    setSignInType: (signInType: string): void => {
      set((state) => {
        state.signInType = signInType;
      });
    },
    openOTPModal: false,
    setOpenOTPModal: (openOTPModal: boolean) => {
      set((state) => {
        state.openOTPModal = openOTPModal;
      });
    },
  })
);

export default useModalStore;
